import { apiClient } from "./apiClient";
import apiUltils from "./apiUltils";

export default {
  search(params) {
    return apiClient.post(`/rest/search`, params, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  searchWithCancelToken(params, cancelToken) {
    return apiClient.post(`/rest/search`, params, {
      cancelToken: cancelToken,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  getDescriptors(queryObjectType, params, orgParam, channelId) {
    const paramsWithChannel = channelId ? { ...params, channelId } : params;
    return apiClient.get(
      apiUltils.buildParamsListURI(
        `/rest/search/gui/basic/filter/descriptors/${queryObjectType}` +
          (orgParam || ""),
        paramsWithChannel
      )
    );
  },

  getFilterColumns(queryObjectType, params, orgParam, channelId) {
    const paramsWithChannel = channelId ? { ...params, channelId } : params;
    return apiClient.get(
      apiUltils.buildParamsListURI(
        `/rest/search/gui/table/descriptors/${queryObjectType}` +
          (orgParam || ""),
        paramsWithChannel
      )
    );
  },

  getSuggestion(params) {
    return apiClient.get(`/rest${params.url}`);
  },

  getSuggestionActivityState() {
    return apiClient.get(
      `/rest/search/gui/filter/suggestion/lastActivityState`,
      {}
    );
  },

  getSuggestionThirdPartyEnum(filterKey, params) {
    return apiClient.post(
      `/rest/search/gui/filter/suggestion/enum/${filterKey}`,
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },

  getSuggestionGeozoneByLastGeozoneTags(params) {
    return apiClient.post(
      `/rest/search/gui/filter/suggestion/geozoneFiltered/lastGeozoneTags`,
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },

  getSuggestionDeviceByLastGeozoneTags(params) {
    return apiClient.post(
      `/rest/search/gui/filter/suggestion/deviceFiltered/lastGeozoneTags`,
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },

  getSystemTags(params) {
    return apiClient.get(
      `/rest/search/gui/filter/suggestion/device/systemTags`,
      { params: params }
    );
  },

  getPartnerTags(params) {
    return apiClient.get(
      `/rest/search/gui/filter/suggestion/device/partnerTags`,
      { params: params }
    );
  },

  searchCount(params) {
    return apiClient.post("/rest/search/count", params, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },
};
